'use client';

import { useTranslations } from 'next-intl';

import NavLinkItem from '@/components/NavLinkItem';
import ChevronDown from '@/components/SvgIcons/ChevronDown';
import type { NavLinkWithChildren } from '@/config/navigation.config';
import { usePathname } from '@/i18n/navigation';

import styles from './NavDropdown.module.scss';

interface NavDropdownProps {
  link: NavLinkWithChildren;
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const NavDropdown = ({ link, open, onOpen, onClose }: NavDropdownProps) => {
  const t = useTranslations('common');
  const pathname = usePathname();

  const isActive =
    pathname === link.href ||
    pathname.startsWith(`${link.href}/`) ||
    link.children.some(child => pathname === child.href || pathname.startsWith(`${child.href}/`));

  return (
    <NavLinkItem
      href={link.href}
      labelKey={link.labelKey}
      isActive={isActive}
      listItemProps={{ onMouseEnter: onOpen, onMouseLeave: onClose }}
      listItemButtonProps={{ 'aria-haspopup': 'true', 'aria-expanded': open }}
    >
      <span className={styles.container}>
        {t(link.labelKey)}
        <span className={`${styles.chevron} ${open ? styles.open : ''}`} aria-hidden>
          <ChevronDown size={16} />
        </span>
      </span>
    </NavLinkItem>
  );
};

export default NavDropdown;
